module.exports = "/packs/images/homepage/activity/football_retina~cfa8d3a80a9c7b2a540e7bbba960e2f2.jpg";